module.exports = __webpack_public_path__ + "static/img/alert-ico.116b50c.svg";